import {Sex} from "./user";

/**
 * Тип записи в избранном.
 *  - `registered` — избранный привязан к зарегистрированному `login`.
 *  - `guest` — избранный привязан к гостевому `login` (нику без регистрации).
 *
 * Подробности см. в `docs/specs/favorites.md`.
 */
export enum FavoriteKind {
    Registered = 'registered',
    Guest = 'guest'
}

export const FavoriteWarningType = {
    GuestInactive: 'guest_inactive',
    GuestNowRegistered: 'guest_now_registered',
} as const;

/**
 * Предупреждение, отображаемое на записи избранного (иконка + тултип).
 *  - `guest_inactive` — гостевой ник давно (`sinceDays` > 90) не входил в чат.
 *  - `guest_now_registered` — ник, под которым была сделана гостевая запись,
 *     теперь зарегистрирован (возможно, это другой человек).
 */
export type FavoriteWarning =
    | { type: typeof FavoriteWarningType.GuestInactive, sinceDays: number }
    | { type: typeof FavoriteWarningType.GuestNowRegistered }

// Фабрики (создатели) объектов
export const createFavoriteWarning = {
    guestInactive: (sinceDays: number): FavoriteWarning => ({
        type: FavoriteWarningType.GuestInactive,
        sinceDays
    }),
    guestNowRegistered: (): FavoriteWarning => ({
        type: FavoriteWarningType.GuestNowRegistered
    }),
};

/**
 * Запись избранного, передаваемая клиенту.
 *
 * Поле `sex` присутствует только для `kind='registered'` — для отрисовки рамки пола
 * в `AvatarItemComponent` даже когда такой пользователь сейчас офлайн.
 * Для гостей пол после выхода неизвестен и не отдаётся.
 */
export interface FavoriteDto {
    readonly login: string
    readonly kind: FavoriteKind
    readonly sex?: Sex
    readonly addedAt: number
    readonly warnings?: FavoriteWarning[]
}
